import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum LoadingIndicatorModes {
  Full = 'full',
  Dialog = 'dialog',
}

@Injectable({ providedIn: 'root' })
export class LoadingStateService {
  private counter = 0;

  private _loading = new BehaviorSubject<boolean>(false);
  public loading$ = this._loading.asObservable();

  private _mode = new BehaviorSubject<LoadingIndicatorModes>(LoadingIndicatorModes.Full);
  public mode$ = this._mode.asObservable();

  public resolving() {
    this.counter++;
    if (!this._loading.value) {
      return this._loading.next(true);
    }
  }

  public resolved() {
    this.counter--;
    if (this.counter === 0) {
      return this._loading.next(false);
    }
  }

  /** Set the current loading mode, Full | Dialog */
  public setMode(type: LoadingIndicatorModes) {
    this._mode.next(type);
  }

  public get mode() {
    return this._mode.value;
  }
}
